// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslateButton-cls1_AWi","cls2":"TranslateButton-cls2_uBG TranslateButton-cls1_AWi"};